export default {
  form: {
    tax_id: {
      label: 'Numero fiscale',
      placeholder: 'Inserisci il numero fiscale',
    },
    has_vat: {
      label: 'La tua attività è registrata ai fini IVA?',
    },
    vat_id: {
      label: 'IVA',
      placeholder: 'IVA',
      tooltip: 'Il numero IVA è un codice fiscale univoco che identifica la tua attività',
    },
    tax_percentage: {
      label: 'Percentuale IVA',
      placeholder: 'Percentuale IVA',
    },
    has_dedicated_products_tax: {
      label: "L'aliquota fiscale varia in base al prodotto",
    },
  },
  buttons: {
    next: 'Avanti',
    back: 'Indietro',
    skip: 'Salta',
  },
};
